class CalculateQuoterBricks {
    brickIds;
    propertyId;
    traderId;
    averagePrice;
    pricePerBrick;
    revolvingFund;
    subtotal;
    totalRevolvingFund;
    totalAmount;
    bricksQuantity;
    property;
    constructor(data) {
        this.brickIds = data.brickIds;
        this.propertyId = data.propertyId;
        this.traderId = data.traderId;
        this.averagePrice = data.averagePrice;
        this.pricePerBrick = data.pricePerBrick;
        this.revolvingFund = data.revolvingFund;
        this.subtotal = data.subtotal;
        this.totalRevolvingFund = data.totalRevolvingFund;
        this.totalAmount = data.totalAmount;
        this.bricksQuantity = data.bricksQuantity;
        this.property = data.property;
    }
}
export default CalculateQuoterBricks;
